





































































import { Component, Vue } from 'vue-property-decorator';
import user from '@/store/modules/users';
import { resendVerificationLink, verifyNewUser } from '@/store/api';
import { Helpers } from '@/tools/helpers';

@Component({
  components: {},
})
export default class Login extends Vue {
  private econ_vid = require('@/assets/videos/EconomX_hero_animation.mp4');
  private ecx_logo_image = require('@/assets/EconomX logo - on light bg.svg');
  private loggingin: boolean = false;
  private valid: boolean = false;
  private account: any = {
    email: null,
    password: null,
  };
  private urlToRedirect: string | string[] | null = null;

  private created() {
    this.urlToRedirect = this.$route.query.url;
    if (this.$store.getters.currentUser) {
      if (this.urlToRedirect) {
        this.$router.push({ path: `/${this.urlToRedirect}` });
      } else {
        this.$router.push({ path: '/dashboard' });
      }
    }

    if (this.isVerifyPage && this.$route.params.code) {
      this.verify();
    }

    if (this.isReverifyPage && this.$route.params.code) {
      this.reverify();
    }

    if (this.isReverifyInvitedPage && this.$route.params.organization_id && this.$route.params.code) {
      this.reverify();
    }
  }

  get isVerifyPage() {
    return this.$route.name === 'VerifyUser';
  }

  get isReverifyPage() {
    return this.$route.name === 'ReverifyUser';
  }

  get isReverifyInvitedPage() {
    return this.$route.name === 'ReverifyInvited';
  }

  private verify() {
    const params = { code: this.$route.params.code, organization_id: this.$route.params.organization_id, user_type: this.isReverifyInvitedPage ? 'user' : 'limited' };
    verifyNewUser(params).then((result: any) => {
      if (result && result.status === 200) {
        this.$swal('Success', 'Your email is verified', 'success').then((res: any) => {
        });
      }
    });
  }

  private async reverify() {
    return await resendVerificationLink(this.$route.params.code, this.$route.params.organization_id).then((result: any) => {
      if (result && result.status === 200) {
        this.$swal(
          'Resend verification successful',
          'You will receive an email shortly to verify your email address.',
          'success',
        ).then((res: any) => {
          this.$router.push({ path: '/login' });
        });
      }
    });
  }

  private login() {
    if ((this.$refs.loginform as any).validate() && this.valid) {
      this.loggingin = true;
      user.login(this.account).then((result: any) => {
        if (this.$store.getters.currentUser) {
          this.$events.fire('userLoggedIn');
          if (this.urlToRedirect) {
            this.$router.push({ path: `/${this.urlToRedirect}` });
          } else {
            if (this.$store.getters.currentUser.user_type === 'limited') {
              this.$router.push({ path: `/${Helpers.projectNetworkLabel.replace(/\s+/g, '-').toLowerCase()}` });
            } else {
              this.$router.push({ path: '/dashboard' });
            }
          }
        }
        this.loggingin = false;
      });
    }
  }
}
